module.exports = __webpack_public_path__ + "static/media/incident_category-other.ff113507.svg";